/* pf-header.js — Verhalten des Kopfbereichs.

   Fuenf Dinge, sonst nichts:
     1. Laufband schliessen (merkt sich das fuer die Sitzung)
     2. Produkte-Menue auf und zu. Am Desktop ist es eine Klappflaeche, auf
        dem Telefon dieselbe Flaeche als Lade. Dasselbe Markup, dieselbe
        Zustandsklasse, nur anderes CSS.
     3. Warenkorb-Knopf oeffnet die Warenkorb-Lade statt der Warenkorb-Seite
     4. Suchvorschlaege ueber /search/suggest.json
     5. Schnellzugriff: Pfeil und Verlauf ausblenden, sobald man am Ende ist

   Ohne JavaScript bleibt der Kopf benutzbar: Suchfeld und Formular
   funktionieren, das Produkte-Menue ist dann ueber den Link auf die
   Kategorieseite erreichbar, der Warenkorb-Knopf fuehrt auf /cart. */
(function () {
  'use strict';

  var root = document.querySelector('[data-pf-header]');
  if (!root) return;

  var OPEN = 'is-open';
  var MERKER = 'pfh-band-zu';

  /* ── Laufband ──────────────────────────────────────────────────────────────────── */
  var band = root.querySelector('[data-pfh-band]');
  if (band) {
    try {
      if (sessionStorage.getItem(MERKER) === '1') band.hidden = true;
    } catch (e) { /* privates Fenster: dann bleibt das Band eben stehen */ }

    var bandX = root.querySelector('[data-pfh-band-x]');
    if (bandX) {
      bandX.addEventListener('click', function () {
        band.hidden = true;
        try { sessionStorage.setItem(MERKER, '1'); } catch (e) {}
      });
    }
  }

  /* ── Produkte-Menue ──────────────────────────────────────────────────────────────── */
  var mega = root.querySelector('[data-pfh-mega]');
  var oeffner = Array.prototype.slice.call(root.querySelectorAll('[data-pfh-open]'));
  var schliesser = Array.prototype.slice.call(root.querySelectorAll('[data-pfh-close]'));
  var zuletzt = null;

  function mobil() {
    return window.matchMedia('(max-width: 999px)').matches;
  }

  function setzeMenue(auf) {
    root.classList.toggle(OPEN, auf);
    oeffner.forEach(function (b) { b.setAttribute('aria-expanded', auf ? 'true' : 'false'); });
    // Nur auf dem Telefon sperren: dort liegt die Lade ueber der Seite.
    document.documentElement.style.overflow = (auf && mobil()) ? 'hidden' : '';
    if (auf) {
      zuletzt = document.activeElement;
      var ziel = mega && mega.querySelector('a, button');
      if (ziel && mobil()) ziel.focus();
    } else if (zuletzt && zuletzt.focus) {
      zuletzt.focus();
      zuletzt = null;
    }
  }

  oeffner.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      setzeMenue(!root.classList.contains(OPEN));
    });
  });
  schliesser.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      setzeMenue(false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains(OPEN)) setzeMenue(false);
  });

  // Am Desktop schliesst ein Klick daneben. Auf dem Telefon macht das der Schleier.
  document.addEventListener('click', function (e) {
    if (!root.classList.contains(OPEN) || mobil()) return;
    if (root.contains(e.target)) return;
    setzeMenue(false);
  });

  // Beim Wechsel der Breite den Zustand zuruecksetzen, sonst bleibt beim
  // Drehen des Telefons die Seitensperre haengen.
  window.addEventListener('resize', function () {
    if (!root.classList.contains(OPEN)) return;
    document.documentElement.style.overflow = mobil() ? 'hidden' : '';
  });

  /* ── Warenkorb ───────────────────────────────────────────────────────
     Frueher hat das theme.Header.init() erledigt. Das laeuft aber nur mit
     dem alten Header-Abschnitt (data-section-type="header-section"), also
     muss der neue Kopf die Lade selbst oeffnen. Die Lade gibt es nur beim
     Warenkorb-Typ „Lade“ und nicht auf /cart selbst; dann bleibt es beim
     normalen Link. Geoeffnet wird ueber pf-cart.js (PFCart.open), das die
     Methode des Themes samt Fokusfalle benutzt. */
  var korbKnopf = root.querySelector('[data-pfh-cart]');
  if (korbKnopf) {
    korbKnopf.addEventListener('click', function (e) {
      if (korbKnopf.getAttribute('data-link-type') !== 'drawer') return;
      if (!document.getElementById('sidebar-cart')) return;
      e.preventDefault();
      if (root.classList.contains(OPEN)) setzeMenue(false);
      if (window.PFCart && window.PFCart.open) {
        window.PFCart.open();
      } else {
        document.getElementById('sidebar-cart').classList.add('show');
        document.body.classList.add('show_overlay');
      }
    });
  }

  /* ── Schnellzugriff ──────────────────────────────────────────────────────────────── */
  var rail = root.querySelector('[data-pfh-rail]');
  var quick = root.querySelector('[data-pfh-quick]');
  if (rail && quick) {
    var messen = function () {
      var max = rail.scrollWidth - rail.clientWidth;
      quick.classList.toggle('pfh-rail-end', !(max > 4 && rail.scrollLeft / max < 0.96));
    };
    rail.addEventListener('scroll', messen, { passive: true });
    window.addEventListener('resize', messen);
    messen();

    var nudge = root.querySelector('[data-pfh-nudge]');
    if (nudge) {
      nudge.addEventListener('click', function () {
        rail.scrollBy({ left: Math.round(rail.clientWidth * 0.8), behavior: 'smooth' });
      });
    }
  }

  /* ── Suche ───────────────────────────────────────────────────────────────────── */
  var suchKnopf = root.querySelector('[data-pfh-search-toggle]');
  var suchZeile = root.querySelector('[data-pfh-searchrow]');
  if (suchKnopf && suchZeile) {
    suchKnopf.addEventListener('click', function () {
      var zu = suchZeile.hidden;
      suchZeile.hidden = !zu;
      suchKnopf.setAttribute('aria-expanded', zu ? 'true' : 'false');
      if (zu) {
        var feld = suchZeile.querySelector('input');
        if (feld) feld.focus();
      }
    });
  }

  var waehrung = root.getAttribute('data-waehrung') || 'EUR';
  var preisFormat;
  try {
    preisFormat = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: waehrung });
  } catch (e) {
    preisFormat = { format: function (n) { return n + ' ' + waehrung; } };
  }

  function bildKachel(url, alt) {
    if (!url) return '<span class="pfh-sug-img"></span>';
    var s = document.createElement('span');
    s.className = 'pfh-sug-img';
    var i = document.createElement('img');
    i.src = url;
    i.alt = alt || '';
    i.loading = 'lazy';
    s.appendChild(i);
    return s.outerHTML;
  }

  Array.prototype.slice.call(root.querySelectorAll('[data-pfh-search]')).forEach(function (form) {
    var feld = form.querySelector('input[name="q"]');
    var box = form.querySelector('[data-pfh-sug]');
    if (!feld || !box) return;

    var timer = null;
    var laufend = null;

    function zu() { box.hidden = true; box.innerHTML = ''; }

    function zeige(daten, frage) {
      var r = (daten && daten.resources && daten.resources.results) || {};
      var produkte = r.products || [];
      var kollektionen = r.collections || [];

      if (!produkte.length && !kollektionen.length) {
        box.innerHTML = '<div class="pfh-sug-empty">Nichts gefunden. Ruf uns an, wir schauen nach.</div>';
        box.hidden = false;
        return;
      }

      var teile = [];
      if (kollektionen.length) {
        teile.push('<div class="pfh-sug-h">Kategorien</div>');
        kollektionen.forEach(function (c) {
          teile.push('<a class="pfh-sug-item" href="' + c.url + '"><span class="pfh-sug-t">' + escape(c.title) + '</span></a>');
        });
      }
      if (produkte.length) {
        teile.push('<div class="pfh-sug-h">Produkte</div>');
        produkte.forEach(function (p) {
          var preis = '';
          var n = parseFloat(p.price);
          if (!isNaN(n)) preis = '<span class="pfh-sug-p">' + preisFormat.format(n) + '</span>';
          var bild = (p.featured_image && p.featured_image.url) || p.image || '';
          teile.push('<a class="pfh-sug-item" href="' + p.url + '">' + bildKachel(bild, p.title) +
            '<span class="pfh-sug-t">' + escape(p.title) + '</span>' + preis + '</a>');
        });
      }
      teile.push('<a class="pfh-sug-all" href="/search?q=' + encodeURIComponent(frage) + '">Alle Treffer für „' + escape(frage) + '“ →</a>');

      box.innerHTML = teile.join('');
      box.hidden = false;
    }

    function escape(t) {
      var d = document.createElement('span');
      d.textContent = t == null ? '' : String(t);
      return d.innerHTML;
    }

    function fragen() {
      var q = feld.value.trim();
      if (q.length < 2) { zu(); return; }
      if (laufend) laufend.abort();
      laufend = typeof AbortController === 'function' ? new AbortController() : null;

      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url, laufend ? { signal: laufend.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d) zeige(d, q); })
        .catch(function () { /* abgebrochen oder offline: Vorschlaege bleiben aus */ });
    }

    feld.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(fragen, 180);
    });
    feld.addEventListener('focus', function () { if (feld.value.trim().length > 1) fragen(); });
    feld.addEventListener('keydown', function (e) { if (e.key === 'Escape') zu(); });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) zu();
    });
  });
})();
